module.exports = __webpack_public_path__ + "img/logo.757c4f12.png";